module.exports = __webpack_public_path__ + "89be15b1dab6b7de37758274ec50d6e4.png";